import React from "react";

import "./PrintTemplate.css";
import PrintTemplateS2 from "./PrintTemplateS2";

interface Props{
    toningData:any;
}
export class PrintTemplateS2Printer extends React.PureComponent<Props> {
  render() {
    return (
      <PrintTemplateS2 toningData={this.props.toningData} />
    );
  }
}
